var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import styled from "styled-components";
import { usePresentationComponent } from "../../../AppContext";
import { Button } from "../Button/Button";
import { getClassName } from "../../../helpers";
import { SvgIcon } from "../../../icons";
import { Popper } from "../../Popper/Popper";
var MENU = "ws-menu";
var MENU_WRAP = MENU + "-container";
var MENU_DROPDOWN = MENU + "-dropdown";
var allowedPlacements = [
    "bottom-start",
    "bottom-end",
    "top-start",
    "top-end",
];
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false
        };
        _this.menuRef = React.createRef();
        _this.buttonRef = React.createRef();
        _this.hideMenu = function (e) {
            var _a;
            if (!_this.state.show) {
                return;
            }
            if ((_a = _this.menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(e === null || e === void 0 ? void 0 : e.target)) {
                return;
            }
            _this.setState({ show: !_this.state.show });
        };
        _this.toggleMenu = function (e) {
            var _a, _b;
            _this.setState({ show: !_this.state.show });
            (_b = (_a = _this.props.buttonProps) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        return _this;
    }
    Object.defineProperty(Menu.prototype, "ownProps", {
        get: function () {
            return this.props;
        },
        enumerable: false,
        configurable: true
    });
    Menu.prototype.componentDidMount = function () {
        document.addEventListener("click", this.hideMenu);
    };
    Menu.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.hideMenu);
    };
    Menu.prototype.render = function () {
        var _a;
        var _b = this.ownProps, className = _b.className, _c = _b.label, label = _c === void 0 ? "" : _c, icon = _b.icon, children = _b.children, buttonProps = _b.buttonProps, name = _b.name;
        return (React.createElement(MenuWrap, { ref: this.menuRef, className: getClassName(className, MENU_WRAP) },
            React.createElement(Button, __assign({ variant: "clear" }, buttonProps, { ref: this.buttonRef, type: "button", onClick: this.toggleMenu }),
                React.createElement(SvgIcon, { type: icon }),
                " ",
                label),
            React.createElement(Popper, { className: MENU + " ws" + (name ? "-" + name : "") + "-menu-popover", sameWidth: true, allowedPlacements: allowedPlacements, placement: (_a = this.props.placement) !== null && _a !== void 0 ? _a : "bottom-left", referenceElement: this.buttonRef, show: this.state.show, onOverlayClick: this.hideMenu },
                React.createElement(MenuPopoverComponent, { className: MENU_DROPDOWN }, children))));
    };
    return Menu;
}(React.PureComponent));
export { Menu };
var MenuRenderer = function (_a) {
    var className = _a.className, icon = _a.icon, _b = _a.label, label = _b === void 0 ? "" : _b, context = _a.context, items = _a.items, onChange = _a.onChange, value = _a.value;
    var Component = usePresentationComponent([context + ".menu", "menu"]) || Menu;
    return (React.createElement(Component, { context: context, className: className, icon: icon, label: label, onChange: onChange, value: value, items: items }, items));
};
var MenuWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: inline;\n"], ["\n    position: relative;\n    display: inline;\n"])));
export var MenuPopoverComponent = styled.div.attrs(function (props) { return props; })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: #fff;\n    border: 1px solid #ccc;\n    padding: .5em;\n    margin-top: .5em;\n"], ["\n    background: #fff;\n    border: 1px solid #ccc;\n    padding: .5em;\n    margin-top: .5em;\n"])));
export var ReactiveMenu = function (props) {
    var formOptions = useFormApi();
    var _a = useFieldApi(props).input, name = _a.name, value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? null : _b;
    var onValueChange = React.useCallback(function (value) {
        onChange(value[name]);
    }, [name, onChange]);
    var fieldValue = React.useMemo(function () {
        var _a;
        return (_a = {}, _a[name] = value, _a);
    }, [name, value]);
    return React.createElement(MenuRenderer, __assign({}, props, { onChange: onValueChange, value: fieldValue, items: formOptions.renderForm(props.fields, formOptions) }));
};
var templateObject_1, templateObject_2;
